<template>
  <footer class="ocsFooter">

    <!-- =========================================
         TOUR / PARTNER LOGOS
    ========================================== -->

    <section class="partnersSection">

      <div class="partnersIntro">

        <div class="partnersLine"></div>

        <span class="partnersEyebrow">
          TRUSTED BY PROFESSIONAL GOLF
        </span>

        <h3>
          Powering leading golf tours
        </h3>

        <p>
          OCS Sport provides technology and tournament management solutions
          for professional golf organisations around the world.
        </p>

      </div>


      <!-- Desktop -->
      <div class="slider desktop">

        <VueSlickCarousel
          :autoplay="true"
          :infinite="true"
          :speed="1000"
          :autoplaySpeed="6000"
          :slidesToShow="4"
          :slidesToScroll="1"
        >

          <div class="sponsorSlide">
            <div class="sponsorLogoWrap">
              <b-img
                class="sponImg"
                :src="spons[6].acf.image"
              ></b-img>
            </div>
          </div>

          <div class="sponsorSlide">
            <div class="sponsorLogoWrap">
              <b-img
                class="sponImg aus"
                :src="spons[1].acf.image"
              ></b-img>
            </div>
          </div>

          <div class="sponsorSlide">
            <div class="sponsorLogoWrap">
              <b-img
                class="sponImg"
                :src="spons[2].acf.image"
              ></b-img>
            </div>
          </div>

          <div class="sponsorSlide">
            <div class="sponsorLogoWrap">
              <b-img
                class="sponImg"
                :src="spons[3].acf.image"
              ></b-img>
            </div>
          </div>

          <div class="sponsorSlide">
            <div class="sponsorLogoWrap">
              <b-img
                class="sponImg"
                :src="spons[4].acf.image"
              ></b-img>
            </div>
          </div>

          <div class="sponsorSlide">
            <div class="sponsorLogoWrap">
              <b-img
                class="sponImg alps"
                :src="spons[0].acf.image"
              ></b-img>
            </div>
          </div>

        </VueSlickCarousel>

      </div>


      <!-- Mobile -->
      <div class="slider mob">

        <VueSlickCarousel
          :autoplay="true"
          :infinite="true"
          :speed="1000"
          :autoplaySpeed="6000"
          :slidesToShow="1.5"
          :slidesToScroll="1"
        >

          <div
            v-for="(sponsor, index) in spons"
            :key="index"
            class="sponsorSlide"
          >

            <div class="sponsorLogoWrap">

              <b-img
                class="sponImg"
                :src="sponsor.acf.image"
              ></b-img>

            </div>

          </div>

        </VueSlickCarousel>

      </div>

    </section>


    <!-- =========================================
         FOOTER
    ========================================== -->

    <section class="footerMain">

      <b-container>

        <div class="footerGrid">


          <!-- OCS Logo -->
          <div class="footerBrand">

            <a
              href="https://ocs-software.com/"
              target="_blank"
              rel="noopener noreferrer"
            >

              <b-img
                class="logo"
                src="https://wp-ocssport.ocs-sport.com/ocs-studios/wp-content/uploads/sites/2/2023/03/OCS_Software_Logo_2017_WO.png"
              ></b-img>

            </a>

          </div>


          <!-- About -->
          <div class="footerAbout">

            <div class="footerEyebrow">
              WE'RE CONNECTED
            </div>

            <p class="FooterText">
              OCS Sport is part of OCS Software, offering well established
              digital skills to businesses who want leading edge technology
              solutions.
            </p>

          </div>


          <!-- Companies -->
          <div class="footerCompanies">

            <div class="footerEyebrow">
              OCS SOFTWARE
            </div>

            <div class="SupportLogoBlock">

              <a
                href="https://ocs-digital.com/"
                target="_blank"
                rel="noopener noreferrer"
              >

                <img
                  class="supportLogoSplash"
                  src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2023/05/OCS-Digital_white.png"
                >

              </a>


              <a
                href="https://simpark.club/"
                target="_blank"
                rel="noopener noreferrer"
              >

                <img
                  class="supportLogoSplash simparkLogo"
                  src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2024/11/SimPark_White_Sqaure.png"
                >

              </a>

            </div>

          </div>


          <!-- Contact -->
          <div class="footerContact">

            <div class="footerEyebrow">
              CONTACT
            </div>

            <p class="copyright">
              © OCS Sport is a Trading name of iOffice Ltd
            </p>

            <a
              class="phone"
              href="tel:+442071834397"
            >
              +44 (0) 207 183 4397
            </a>

          </div>

        </div>

      </b-container>

    </section>

  </footer>
</template>

<script>
import axios from "axios";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
export default {
  name: "footer",
  components: { VueSlickCarousel },
  data() {
    return {
      spons: [],
    };
  },
  methods: {
      isMobile() {
          if( screen.width <= 500 ) {
              return true;
          }
          else {
              return false;
          }
      },
  },
  mounted() {
    axios //add API Call
      .get(process.env.VUE_APP_API_URL + "/wp-json/wp/v2/sponsors?per_page=20") // Page number changed on each page based on JSON page id you are calling
      .then((response) => (this.spons = response.data)); //API data wanted pulled out
  },
};
</script>

<style scoped>

/* =========================================
   FOOTER
========================================= */

.ocsFooter {
  width: 100%;
}


/* =========================================
   PARTNERS
========================================= */

.partnersSection {
  padding: 85px 0 75px;

  background: #f4f6f8;

  overflow: hidden;
}

.partnersIntro {
  max-width: 750px;

  margin: 0 auto 45px;

  padding: 0 20px;

  text-align: center;
}

.partnersLine {
  width: 50px;
  height: 4px;

  margin: 0 auto 22px;

  background: #00aeef;
}

.partnersEyebrow {
  display: block;

  margin-bottom: 14px;

  color: #00aeef;

  font-size: 10px;
  font-weight: 700;

  letter-spacing: 1.8px;
}

.partnersIntro h3 {
  margin: 0 0 15px;

  color: #111820;

  font-size: 34px;
  line-height: 1.2;

  font-weight: 700;

  letter-spacing: -0.4px;
}

.partnersIntro p {
  max-width: 650px;

  margin: 0 auto;

  color: #68717a;

  font-size: 15px;
  line-height: 1.7;
}


/* =========================================
   SLIDER
========================================= */

.slider {
  width: 100%;

  padding: 15px 0;
}

::v-deep .slick-slider > button {
  display: none !important;
}

::v-deep .slick-track {
  display: flex;

  align-items: center;
}

::v-deep .slick-slide {
  height: auto;
}


/* =========================================
   SPONSOR SLIDE
========================================= */

.sponsorSlide {
  display: flex !important;

  justify-content: center;
  align-items: center;

  height: 150px;

  padding: 20px;
}

.sponsorLogoWrap {
  display: flex;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;

  padding: 20px 35px;

  background: #ffffff;

  border: 1px solid #e4e8eb;

  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease;
}

.sponsorLogoWrap:hover {
  transform: translateY(-4px);

  box-shadow:
    0 10px 25px rgba(0, 0, 0, 0.08);
}


/* =========================================
   SPONSOR LOGOS
========================================= */

.sponImg {
  display: block;

  width: 100%;
  max-width: 230px;

  max-height: 75px;

  object-fit: contain;
}

.sponImg.alps {
  max-height: 70px;
}

.sponImg.aus {
  max-height: 80px;
}


/* =========================================
   FOOTER MAIN
========================================= */

.footerMain {
  padding: 55px 0 45px;

  background: #003460;

  color: #ffffff;
}


/* =========================================
   GRID
========================================= */

.footerGrid {
  display: grid;

  grid-template-columns:
    1fr
    1.6fr
    1fr
    1.2fr;

  gap: 45px;

  align-items: center;
}


/* =========================================
   BRAND
========================================= */

.footerBrand {
  display: flex;

  align-items: center;
}

.footerBrand a {
  display: inline-block;
}

.logo {
  display: block;

  width: 120px;
}


/* =========================================
   FOOTER HEADINGS
========================================= */

.footerEyebrow {
  margin-bottom: 14px;

  color: #ffffff;

  font-size: 10px;
  font-weight: 700;

  letter-spacing: 1.6px;
}


/* =========================================
   ABOUT
========================================= */

.footerAbout {
  max-width: 350px;
}

.FooterText {
  margin: 0;

  color: rgba(255, 255, 255, 0.72);

  font-size: 13px;

  line-height: 1.65;
}


/* =========================================
   COMPANIES
========================================= */

.SupportLogoBlock {
  display: flex;

  align-items: center;

  gap: 20px;
}

.supportLogoSplash {
  display: block;

  width: 55px;
  height: 55px;

  object-fit: contain;

  transition:
    opacity 0.25s ease,
    transform 0.25s ease;
}

.supportLogoSplash:hover {
  opacity: 0.75;

  transform: translateY(-2px);
}

.simparkLogo {
  width: 52px;
  height: 52px;
}


/* =========================================
   CONTACT
========================================= */

.copyright {
  margin: 0 0 10px;

  color: rgba(255, 255, 255, 0.65);

  font-size: 11px;

  line-height: 1.5;
}

.phone {
  color: #ffffff !important;

  font-size: 14px;

  font-weight: 600;

  text-decoration: none !important;

  transition: color 0.25s ease;
}

.phone:hover {
  color: #00aeef !important;
}


/* =========================================
   MOBILE SLIDER
========================================= */

.mob {
  display: none;
}


/* =========================================
   1100px
========================================= */

@media only screen and (max-width: 1100px) {

  .footerGrid {
    grid-template-columns:
      1fr
      1.5fr
      1fr;

    gap: 35px;
  }

  .footerContact {
    grid-column: span 3;
  }

}


/* =========================================
   900px
========================================= */

@media only screen and (max-width: 900px) {

  .desktop {
    display: none;
  }

  .mob {
    display: block;
  }

  .footerGrid {
    grid-template-columns: 1fr 1fr;

    gap: 40px;
  }

  .footerContact {
    grid-column: auto;
  }

}


/* =========================================
   768px
========================================= */

@media only screen and (max-width: 768px) {

  .partnersSection {
    padding: 65px 0 55px;
  }

  .partnersIntro h3 {
    font-size: 29px;
  }

  .partnersIntro p {
    font-size: 14px;
  }

  .sponsorSlide {
    height: 135px;

    padding: 12px;
  }

  .sponsorLogoWrap {
    padding: 15px;
  }

  .sponImg {
    max-width: 190px;

    max-height: 65px;
  }

  .footerMain {
    padding: 45px 20px;
  }

  .footerGrid {
    grid-template-columns: 1fr;

    text-align: center;

    gap: 30px;
  }

  .footerBrand {
    justify-content: center;
  }

  .footerAbout {
    max-width: 450px;

    margin: 0 auto;
  }

  .SupportLogoBlock {
    justify-content: center;
  }

  .footerContact {
    grid-column: auto;
  }

}


/* =========================================
   500px
========================================= */

@media only screen and (max-width: 500px) {

  .partnersSection {
    padding: 50px 0 45px;
  }

  .partnersIntro {
    margin-bottom: 30px;
  }

  .partnersIntro h3 {
    font-size: 26px;
  }

  .partnersIntro p {
    font-size: 13px;
  }

  .sponsorSlide {
    height: 125px;
  }

  .sponsorLogoWrap {
    padding: 12px;
  }

  .sponImg {
    max-width: 150px;

    max-height: 55px;
  }

  .footerMain {
    padding: 40px 20px;
  }

  .logo {
    width: 110px;
  }

}

</style>